import { useCallback } from 'react';
import { useAsyncFunction } from '../../utils/hooks/useAsyncFunction';
import { useProperty } from './useProperty';
import { useObjectTypeId } from './useObjectTypeId';
import { propertyValidationRulesCache } from '../../cache';
import { useValidationRulesOverride } from '../context/ValidationRulesOverrideContext';
import { useRpcClient } from '../../client/useRpcClient';
import { getOwnProperty } from '../../utils/getOwnProperty';
export const usePropertyValidationRules = (options = {
  skip: false
}) => {
  const property = useProperty();
  const objectTypeId = useObjectTypeId();
  const validationRulesOverride = useValidationRulesOverride();
  const rpcClient = useRpcClient();
  const getRules = useCallback(() => {
    // If we have validation rules override, return them directly
    if (validationRulesOverride) {
      return Promise.resolve(validationRulesOverride);
    }
    return propertyValidationRulesCache.get(objectTypeId, rpcClient).then(result => getOwnProperty(result, property.name));
  }, [objectTypeId, property.name, validationRulesOverride, rpcClient]);
  return useAsyncFunction(getRules, options);
};